import { lazy } from 'react';
import { PageRouter } from '@tools/ui/types';

const DailyBalances = lazy(
  () =>
    import(
      /* webpackChunkName: "JpmReportRoutes" */ '../pages/jpm-report/daily-balances'
    )
);

const ManualAdjustments = lazy(
  () =>
    import(
      /* webpackChunkName: "JpmReportRoutes" */ '../pages/jpm-report/manual-adjustments'
    )
);

const TechnicalLines = lazy(
  () =>
    import(
      /* webpackChunkName: "JpmReportRoutes" */ '../pages/jpm-report/technical-lines'
    )
);

export const jpmReportRoutes: PageRouter[] = [
  { name: 'daily', path: '/daily', component: DailyBalances, tabs: [] },
  {
    name: 'technicalLines',
    path: '/technicalLines',
    component: TechnicalLines,
    tabs: []
  },
  {
    name: 'manualAdjustments',
    path: '/manualAdjustments',
    component: ManualAdjustments,
    tabs: []
  }
];
